import AppStore from "../../../stores/AppStore";
import {Field, Form} from "formik";
import NumberInput from "../../commons/Formik/NumberInput/NumberInput";
import CheckboxInput from "../../commons/Formik/CheckboxInput/CheckboxInput";
import TextInput from "../../commons/Formik/TextInput/TextInput";
import {notEmpty} from "../../../helpers/validators";
import React from "react";
import Button from "../../commons/Button/Button";

const DataForm = ({submitForm, isValid}) => {

  const {
    i18n: {
      benefits: {
        active,
        family,
        required,
        name,
        price,
        base,
        save,
      }
    }
  } = AppStore;

  return (
    <Form>
      <Field
        name="family"
        label={family}
        component={TextInput}
        validate={notEmpty(required)}
      />
      <Field
        name="packageName"
        label={name}
        component={TextInput}
        validate={notEmpty(required)}
      />
      <Field
        name="price.value"
        label={price}
        component={NumberInput}
      />
      <Field
        name="isActive"
        label={active}
        component={CheckboxInput}
      />
      <Field
        name="baseBenefit"
        label={base}
        component={CheckboxInput}
      />
      <Button text={save} onClick={submitForm} disabled={!isValid} />
    </Form>
  )
}


export default DataForm;
